import {
  paymentLinkBilledMock,
  paymentLinkCanceledMock,
  paymentLinkExpiredMock,
  paymentLinkPendingNFeMock,
  paymentLinkReservationExpiredMock,
  paymentLinkSentMock,
  paymentLinkRejectedMock,
} from '@fixtures/apis/payment/link'
import { MockFactory } from '@tino-frontend/mocks'
import type { ListPaymentLinksResponse } from '@types'

export const listPaymentLinksMock = new MockFactory<ListPaymentLinksResponse>({
  total: 6,
  payment_links: [
    paymentLinkPendingNFeMock.source,
    paymentLinkReservationExpiredMock.source,
    paymentLinkCanceledMock.source,
    paymentLinkExpiredMock.source,
    paymentLinkSentMock.source,
    paymentLinkBilledMock.source,
    paymentLinkRejectedMock.source,
  ],
})
